<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1">
          <h6>{{ $t('advanced search') }}</h6>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div class="caption">รหัสศูนย์</div>
          <input type="text" v-model="filter.branch_id" />
        </v-flex>
        <v-flex xs12>
          <div class="caption">ชื่อศูนย์</div>
          <input type="text" v-model="filter.branch_name" />
        </v-flex>
        <v-flex xs12>
          <div class="caption">สาขา</div>
          <input type="text" v-model="filter.affiliation" />
        </v-flex>
        <v-flex xs12>
          <div class="caption">จังหวัด</div>
          <input type="text" v-model="filter.province" />
        </v-flex>
        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn @click="clearSearch" color="grey" outline>{{ $t('Clear Search') }}</v-btn>
            <v-btn @click="onSearch" color="primary">{{ $t('Search') }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const initialFilter = {
  branch_id: '',
  branch_name: '',
  affiliation: '',
  province: ''
}
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      filter: { ...initialFilter }
    }
  },
  methods: {
    clearSearch() {
      this.filter = { ...initialFilter }
      this.$emit('onSearch', this.filter)
    },
    onSearch() {
      this.$emit('onSearch', this.filter)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/SearchBranchDialog.vue